import { render, staticRenderFns } from "./MessageContentCard.vue?vue&type=template&id=5ccf9a9c"
import script from "./MessageContentCard.vue?vue&type=script&lang=js"
export * from "./MessageContentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports